import { HttpContextToken } from "@angular/common/http";

export const SILENT_EROROR = new HttpContextToken<boolean>(() => false);

export const CUSTOM_ERROR_MESSAGE = new HttpContextToken<string>(() => '');